import { Text, View } from "react-native";
import { Image } from "expo-image";

import { env } from "~/env";

export function AccountAvatar(props: {
  avatar?: string | null;
  fallbackText?: string | null;
  size?: number;
}) {
  const { avatar, fallbackText, size = 36 } = props;
  const fallback = fallbackText || "";
  const style = { width: size, height: size };
  const avatarUrl = avatar
    ? avatar.startsWith("data:") || avatar.startsWith("http")
      ? avatar
      : `${env.EXPO_PUBLIC_REST_API_BASE_URL}/api/v1/avatar/${avatar}`
    : undefined;
  return (
    <View
      className="relative items-center justify-center overflow-hidden rounded-full"
      style={{ backgroundColor: stringToColour(fallback), ...style }}
    >
      {avatarUrl ? (
        <Image
          source={{ uri: avatarUrl }}
          className="rounded-full"
          contentFit="cover"
          style={style}
        />
      ) : (
        <Text
          style={{
            fontSize: size / 2,
            color: getContrastingTextColor(stringToColour(fallback)),
          }}
          className="text-white"
        >
          {initials(fallback)}
        </Text>
      )}
      {/* <View
        className="border-text-primary/50 absolute right-0 top-0 rounded-full border"
        style={style}
      /> */}
    </View>
  );
}

const stringToColour = (str: string) => {
  let hash = 0;
  str.split("").forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, "0");
  }
  return colour;
};

function initials(name: string, length: number = 2) {
  // also support without space, taking the first N characters
  const parts = name.split(" ");
  if (parts.length === 1) {
    return parts[0].substring(0, length);
  }
  return parts
    .map((part) => part[0])
    .join("")
    .substring(0, length);
}

function getContrastingTextColor(hexBackground: string) {
  // Convert hex to RGB
  const r = parseInt(hexBackground.slice(1, 3), 16);
  const g = parseInt(hexBackground.slice(3, 5), 16);
  const b = parseInt(hexBackground.slice(5, 7), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for bright backgrounds, white for dark backgrounds
  return luminance > 0.5 ? "#000000" : "#ffffff";
}
